import { gql } from '@apollo/client'

export const MERGE_APPLICANT = gql`
  mutation MergeApplicant(
    $duplicateApplicantId: String!
    $primaryApplicantId: String!
  ) {
    mergeApplicant(
      duplicateApplicantId: $duplicateApplicantId
      primaryApplicantId: $primaryApplicantId
    ) {
      id
      status
    }
  }
`

export const APPLICANT_MERGE_PREVIEW = gql`
  query ApplicantMergePreview($duplicateApplicantId: String!) {
    applicantMergePreview(duplicateApplicantId: $duplicateApplicantId) {
      addressCount
      documentCount
    }
  }
`
